/* eslint-disable */
"use strict";
import errorService from "@/services/errorService";
import router from "../router";

var config, service, labels;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  labels = config.VUE_APP_MOL_S_LABELS
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${labels}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "ETICHETTE",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function stampaEtichetta_old(
  tipoStampa,
  report,
  dati,
  salta,
  tipoQuantita
) {
  try {
    if (tipoStampa === "pdf") {
      const source = `${service}/${labels}/${tipoStampa}/${report}?par=${btoa(
        dati
      )}${salta ? "&sk=" + salta : ""}${
        tipoQuantita ? "&tpq=" + tipoQuantita : ""
      }`;
      router.push({ name: "Pdf", params: { source: source } });
      return "";
    } else {
      const response = await fetch(
        `${service}/${labels}/${tipoStampa}/${report}?par=${btoa(dati)}${
          salta ? "&sk=" + salta : ""
        }${tipoQuantita ? "&tpq=" + tipoQuantita : ""}`
      );
      return await response.json();
    }
  } catch (error) {
    console.log("error stampaEtichetta", error);
    errorService.onError(error, "stampaEtichetta");
    return "";
  }
}

async function stampaEtichetta(
  tipoStampa,
  report,
  etichette,
  salta,
  tipoQuantita,
  sorgente,
  forzaQuantita
) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    var strDati;
    const ids = etichette.map((x) => x.id);
    let datiRaw = {
      tipoQta: tipoQuantita,
    };
    if (sorgente === "articoli") {
      datiRaw.articoli = ids;
    } else {
      datiRaw.movimenti = ids;
    }
    const dati = JSON.stringify(datiRaw);
    strDati = `ids=${btoa(dati)}`;
    if (tipoStampa === "pdf") {
      let source = `${service}/${labels}/${tipoStampa}/${report}?${strDati}${
        salta ? "&sk=" + salta : ""
      }${tipoQuantita ? "&tpq=" + tipoQuantita : ""}`;
      if (forzaQuantita) {
        source += `&fq=${forzaQuantita}`;
      }
      router.push({ name: "Pdf", params: { source: source } });
      return "";
    } else {
      const response = await fetch(
        `${service}/${labels}/${tipoStampa}/${report}?${strDati}${
          salta ? "&sk=" + salta : ""
        }${tipoQuantita ? "&tpq=" + tipoQuantita : ""}${
          forzaQuantita ? "&fq=" + forzaQuantita : ""
        }`
      );
      return await response.json();
    }
  } catch (error) {
    console.log("error stampaEtichetta", error);
    errorService.onError(error, "stampaEtichetta");
    return "";
  }
}

async function stampaDiretta(tipoStampa, src) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    if (tipoStampa === "pdf") {
      router.push({ name: "Pdf", params: { source: `${service}/${src}` } });
      return "";
    } else {
      const response = await fetch(`${service}/${src}`);
      return await response.json();
    }
  } catch (error) {
    errorService.onError(error, "stampaDiretta");
    return { status: "error", error: "Errore stampa etichette: " + error };
  }
}

export default {
  getRunMode,
  stampaEtichetta,
  stampaDiretta,
};
